export default {"src":"/_next/static/media/ROL.6cec0bce.svg","height":18,"width":18};